import { Accordion, Carousel, Col, Container, Row } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";

import * as S from "./style";
import saude from "../../assets/svgs/icone-saude.svg";
import educacao from "../../assets/svgs/icone-educacao.svg";
import lazer from "../../assets/svgs/icone-lazer.svg";
import amorSaude from "../../assets/svgs/logo-branco-amorsaude.svg";
import cna from "../../assets/svgs/logo-branco-cna.svg";
import drogasil from "../../assets/svgs/logo-branco-drogasil.svg";
import estacio from "../../assets/svgs/logo-branco-estacio.svg";
import raia from "../../assets/svgs/logo-branco-raia.svg";
import refuturiza from "../../assets/svgs/logo-branco-refuturiza.svg";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Form from "../../components/Form";
import close from "../../assets/svgs/close.svg";
import closeMobile from "../../assets/svgs/close-mobile.svg";
import { Parceiro } from "../../domain/AxiosRequestParceiros";
import ParceiroComponent from "../../components/ParceiroComponent";
import { DefaultButton } from "../../components/DefaultButton";
import CarouselWrapper from "../../components/CarouselWrapper";
import { useCampaign } from "../../context/CampaignContext";
import { Link } from "react-router-dom";
import {
  INITIAL_FORM_DATA,
  SearchFormContext,
} from "../../context/SearchFormDataContext";
import { useGlobalState } from "../../context/GlobalStateContext";
import { handleFAQClick } from "../../utils/gtm";
import { handleCTAClick } from "../../utils/gtm";

const INTERVAL = 3000;

export default function Home() {
  const { state } = useGlobalState();
  const [separetedValue, setSeparetedValue] = useState<any>(["00", "00"]);

  useEffect(() => {
    setSeparetedValue(state.cdtPrices.valor.split(","));
  }, [state.cdtPrices.valor]);
  const {
    state: { cdtPrices },
  } = useGlobalState();
  const [isModal, setModal] = useState(false);
  const { campaignData } = useCampaign();
  const { updateFormData } = useContext(SearchFormContext);
  const [parceiros, setParceiros] = useState<Parceiro[]>();
  const handleToggle = () => {
    setModal(!isModal);
  };

  const handleClick = (e: any) => {
    const title = (e.currentTarget.querySelector('.acordion-titulo') as HTMLElement)?.innerText;
    if (title) {
      handleFAQClick(title);
    }
  };

  useEffect(() => {
    updateFormData(INITIAL_FORM_DATA);
  }, [updateFormData]);

  const replacePlaceholders = (text: string): string => {
    return text
      .replace("{{valor_mensalidade}}", `R$ ${cdtPrices.valor}`)
      .replace("{{valor_clinicogeral}}", `R$ ${cdtPrices.clinico_geral}`)
      .replace("{{valor_demaisespecialidades}}", `R$ ${cdtPrices.demais}`);
  };
  const renderCarousels = () =>
    campaignData.banners?.map((banner, idx) => {
      return (
        <Carousel.Item key={`banner-${idx}`}>
          <picture>
            <source srcSet={banner.img?.mobile} media="(max-width: 30em)" />
            <source srcSet={banner.img?.desktop} />
            <img src={banner.img?.desktop} alt="banner 1" />
          </picture>
          <div className="texto">
            <h1>{banner?.title}</h1>
            <p>{replacePlaceholders(banner?.subtitle)}</p>
          </div>
        </Carousel.Item>
      );
    });

  return (
    <>
      <Header />

      <S.ModalHome className={isModal ? "close" : ""}>
        <div className="bem-vindo">
          <picture>
            <source srcSet={closeMobile} media="(max-width: 60em)" />
            <source srcSet={close} />
            <img
              src={close}
              alt="botão fechar"
              className="close-modal-icon"
              onClick={handleToggle}
            />
          </picture>
          <div className="img-modal-container">
            <img
              src={campaignData.modal.img}
              alt="imagem cartão"
              className="img-modal"
            />
          </div>
          <div className="txt-modal">
            <h1>{campaignData.modal.title}</h1>
            <p>{replacePlaceholders(campaignData.modal.description)}</p>
            <a href={campaignData.salesUrl} onClick={handleCTAClick}>
              <DefaultButton>Saiba Mais</DefaultButton>
            </a>
          </div>
        </div>
      </S.ModalHome>

      <S.Banner>
        <CarouselWrapper interval={INTERVAL}>
          {renderCarousels()}
        </CarouselWrapper>
      </S.Banner>

      <S.Beneficios>
        <Container>
          <Row>
            <Col md={3} className="saude">
              <img src={saude} alt="icone de saúde" />
              <h1>Saúde</h1>
              <p>
                Descontos especiais em consultas médicas, exames laboratoriais,
                odontologia e farmácias.
              </p>
            </Col>
            <Col md={3} className="educacao">
              <img src={educacao} alt="icone de Educação" />
              <h1>Educação</h1>
              <p>Descontos em cursos técnicos e faculdades.</p>
            </Col>
            <Col md={3} className="lazer">
              <img src={lazer} alt="icone de Lazer" />
              <h1>Lazer</h1>
              <p>Hotéis, pousadas, academias e muito mais.</p>
            </Col>
            <Col md={3} className="especiais">
              <img src={campaignData.teamShield} alt="icone de Especiais" />
              <h1>Especiais</h1>
              <p>
                Em breve compartilharemos descontos em benefícios especiais para
                os filiados ao Cartão de TODOS {campaignData.teamName}.
              </p>
            </Col>
            <Link to="beneficios">
              <DefaultButton>SAIBA MAIS</DefaultButton>
            </Link>
          </Row>
        </Container>
      </S.Beneficios>

      <S.Mensalidade>
        <Container>
          <picture>
            <source
              srcSet={campaignData.imgs.preco.bgMobile}
              media="(max-width: 48em)"
            />
            <source srcSet={campaignData.imgs.preco.bgDesktop} />
            <img
              className="mensalidade-bg"
              src={campaignData.imgs.preco.bgDesktop}
              alt="banner torcida"
            />
          </picture>
          <div className="linear-gradient-decoration" />
          <Row>
            <Col md={6}>
              <h1>
                Cartão de TODOS
                <br />
                {campaignData.teamName}
              </h1>
              <p>
                Com o Cartão de TODOS, sua família passa por consultas,
                dentistas e faz exames na hora que precisa, pelo preço que pode
                pagar. E você ainda tem acesso a descontos em educação e lazer.
              </p>
              <Row>
                <div className="mensalidade-prices">
                  <fieldset
                    tabIndex={-1}
                    aria-disabled={true}
                    className="preco centro"
                  >
                    <legend>
                      <span>Mensalidade de apenas</span>
                    </legend>
                    <p>
                      R$<span className="preco-g">{separetedValue[0]}</span>
                      <span className="preco-centavo">
                        ,{separetedValue[1]}
                      </span>
                    </p>
                    <h3>PARA TODA A FAMÍLIA</h3>
                  </fieldset>
                  <fieldset
                    tabIndex={-1}
                    aria-disabled={true}
                    className="preco"
                  >
                    <legend>
                      <span>Consultas</span>
                    </legend>
                    <div className="consultas">
                      <h3>
                        Clínico
                        <br />
                        geral
                      </h3>
                      <p>
                        <span>{state.cdtPrices.clinico_geral}</span>
                      </p>
                    </div>
                    <div className="consultas">
                      <h3>
                        Demais
                        <br />
                        áreas
                      </h3>
                      <p>
                        <span>{state.cdtPrices.demais}</span>
                      </p>
                    </div>
                  </fieldset>
                </div>
              </Row>
              <a className="subBt" href={campaignData.salesUrl} onClick={handleCTAClick}>
                <DefaultButton>solicitar meu cartão</DefaultButton>
              </a>
              <picture>
                <source srcSet={campaignData.imgs.preco.cartaoPreco} />
                <img
                  className="mensalidade-cartao"
                  src={campaignData.imgs.preco.cartaoPreco}
                  alt="cartao de todos"
                />
              </picture>
            </Col>
          </Row>
        </Container>
      </S.Mensalidade>

      <S.Rede>
        <h1>
          Aproveite a nossa rede
          <br />
          com <span>mais de 12.000 parceiros.</span>
        </h1>
        <Container>
          <Row>
            <Col md="2" xs="6">
              <img src={amorSaude} alt="logo amor e saúde" />
              <p>
                consulta a partir
                <br />
                de{" "}
                <span>
                  {replacePlaceholders(campaignData.prices.appointment.general)}
                </span>
              </p>
            </Col>
            <Col md="2" xs="6">
              <img src={cna} alt="logo CNA" />
              <p>
                <span>35%</span> no 1º estágio e<br />
                <span>15%</span> no 2º estágio
              </p>
            </Col>
            <Col md="2" xs="6">
              <img src={drogasil} alt="logo Drogasil" />
              <p>
                até <span>35%</span> em
                <br />
                medicamentos
              </p>
            </Col>
            <Col md="2" xs="6">
              <img src={estacio} alt="Logo Estácio" />
              <p>
                <span>40%</span> nos cursos de
                <br />
                graduação e pós-graduação
              </p>
            </Col>
            <Col md="2" xs="6">
              <img src={raia} alt="Logo Droga Raia" />
              <p>
                até <span>35%</span> em
                <br />
                medicamentos
              </p>
            </Col>
            <Col md="2" xs="6">
              <img src={refuturiza} alt="Logo Refuturiza" />
              <p>
                <span>R$ 9,99</span> por mês
              </p>
            </Col>
          </Row>
        </Container>
        <Form setParceiros={setParceiros} />
      </S.Rede>

      {parceiros && parceiros?.length > 0 && (
        <S.Unidades>
          <Container>
            <Row>
              {parceiros?.map((parceiro) => (
                <ParceiroComponent {...parceiro} />
              ))}
            </Row>
          </Container>
        </S.Unidades>
      )}

      <S.Perguntas>
        <div className="background-container">
          <picture>
            <source
              srcSet={campaignData.imgs.faq.bgMobile}
              media="(max-width: 80em)"
            />
            <source srcSet={campaignData.imgs.faq.bgDesktop} />
            <img src={campaignData.imgs.faq.bgDesktop} alt="banner torcida" />
          </picture>
        </div>
        <Container>
          <Row>
            <Col md="6">
              <div className="texto">
                <h1>PERGUNTAS FREQUENTES</h1>
              </div>
            </Col>
            <Col md="6">
              <Accordion>
                <Accordion.Item eventKey="0" className="acordion-item" onClick={handleClick}>
                  <Accordion.Header>
                    <div className="acordion-titulo">
                      Como pedir meu Cartão de Todos {campaignData.teamName}?
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    Pelo Site: entre em "Solicite seu cartão" preencha o campo
                    "CEP" e siga os processos e passos; Pelo Telefone:
                    4003-5801; ou Pessoalmente: nas Franquias do Cartão de TODOS
                    mais próxima da sua residência.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1" className="acordion-item" onClick={handleClick}>
                  <Accordion.Header>
                    <div className="acordion-titulo">
                      Quanto custa o Cartão de Todos {campaignData.teamName}?
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    O valor da adesão é de{" "}
                    {replacePlaceholders(campaignData.prices.monthlyFee)} e a
                    mensalidade{" "}
                    {replacePlaceholders(campaignData.prices.monthlyFee)}, mas,
                    se você já é um filiado do Cartão de TODOS a adesão passa a
                    ser de {replacePlaceholders(campaignData.prices.monthlyFee)}
                    .
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2" className="acordion-item" onClick={handleClick}>
                  <Accordion.Header>
                    <div className="acordion-titulo">
                      Já tenho o Cartão de TODOS, como eu faço para transferir
                      para o Cartão de Todos {campaignData.teamName}?
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    Vá até a Franquia mais próxima do Cartão de TODOS da sua
                    residência e peça a transferência, que sairá no valor de{" "}
                    {replacePlaceholders(campaignData.prices.monthlyFee)} para
                    obter outros benefícios.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3" className="acordion-item" onClick={handleClick}>
                  <Accordion.Header>
                    <div className="acordion-titulo">
                      Como o Cartão de Todos {campaignData.teamName} funciona?
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    O Cartão de TODOS é uma empresa que trabalha no ramo de
                    cartões de desconto, oferecendo a intermediação de descontos
                    entre pessoas físicas (aderentes) e pessoas jurídicas
                    (empresas parceiras). Ao aderir ao Cartão de TODOS e
                    realizar o pagamento de suas mensalidades, o cliente passa a
                    ter benefícios de descontos em uma vasta rede de empresas
                    parceiras nas áreas de saúde, educação e lazer, espalhadas
                    em todo o brasil. Um ótimo exemplo destes benefícios são os
                    custos de consultas nas clínicas parceiras -{" "}
                    {replacePlaceholders(
                      campaignData.prices.appointment.general
                    )}{" "}
                    clínico geral e{" "}
                    {replacePlaceholders(
                      campaignData.prices.appointment.specialist
                    )}{" "}
                    demais áreas, além de descontos especiais em procedimentos,
                    tratamentos odontológicos completos e exames. O cliente paga
                    uma taxa de emissão do cartão no valor de{" "}
                    {replacePlaceholders(campaignData.prices.monthlyFee)} (paga
                    no ato do contrato) e as mensalidades são no valor de{" "}
                    {replacePlaceholders(campaignData.prices.monthlyFee)}. Você
                    pode colocar como dependentes cônjuge e filhos até 21 anos.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>
        </Container>
        <div className="linear-gradient-decoration" />
      </S.Perguntas>
      <Footer />
    </>
  );
}
